// @flow
import { BRAND_PROMISE } from 'Client/cms/toolkit/constants';
import { BrandPromiseLine } from 'Components/lines/brand-promise-line/BrandPromiseLine';

export const brandPromiseDescriptor = {
  name: BRAND_PROMISE,
  component: BrandPromiseLine,
};
